import * as React from 'react';

export function Home() {
  return (
    <>
      <h1>Welcome to movie app😊✨✨</h1>
    </>
  );
}
